import { useDispatch } from 'react-redux'
import { Redirect, RouteComponentProps, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Loader } from '@carsys/ui'
import { IRegionTag } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'
import { useQuery } from '@cbgms/base/http/use-query'
import RegionForm from 'gms-support/src/app-support/regions/components/RegionForm'
import { deleteRegionTag, getRegionTag, updateRegionTag } from 'gms-support/src/app-support/regions/state/actions'
import { useMemo } from 'react'

type Props = RouteComponentProps<{ regionTagUUID: string }>

const EditRegion = (props: Props) => {
  const {
    match: {
      params: { regionTagUUID }
    }
  } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const history = useHistory()

  const initialRegion = useQuery(['EditRegion', 'getRegionTag', regionTagUUID], async () => {
    const { Data } = await dispatch(getRegionTag(regionTagUUID))
    return Data
  })

  const onSubmit = async (values: IRegionTag) => {
    try {
      await dispatch(updateRegionTag(regionTagUUID, values))
      return values
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async () => {
    notifier.success(t('bank_holidays.successfully_edited'))
  }

  const deleteOptions = useMemo(
    () => ({
      onDelete: async () => {
        await dispatch(deleteRegionTag(regionTagUUID))
        return { Data: { Rejections: [], Warnings: [] } }
      },
      onDeleteSuccess: async () => history.push('/regions'),
      itemName: initialRegion?.data?.Name || '',
      deleteScope: 'bank_holiday'
    }),
    [regionTagUUID, initialRegion?.data?.Name]
  )

  if (initialRegion.isLoading || !initialRegion.data) {
    return <Loader loading />
  }

  if (initialRegion.isError) {
    notifier.error(t('global.something_went_wrong'))

    return <Redirect to='/regions' />
  }

  return (
    <RegionForm
      headerText='bank_holidays.edit_region'
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      deleteOptions={deleteOptions}
      form='edit_region_tag'
      initialValues={initialRegion.data}
      enableReinitialize
    />
  )
}

export default EditRegion
